<div v-if="isOpen" class="tt-w-embedded-submission" tabindex="-1">
  <header v-if="header" class="tt-w-embedded-submission__header">
    <a v-if="header.siteLink" class="tt-w-embedded-submission__link" :href="header.siteLink" target="_blank" rel="nofollow">
      <img class="tt-w-embedded-submission__image" :src="header.imgUrl" :alt="header.siteName">
    </a>
    <img v-else class="tt-w-embedded-submission__image" :src="header.imgUrl" :alt="header.siteName">
  </header>
  <div class="tt-w-embedded-submission__main" :role="header ? 'main' : null">
  <div v-if="!isFormLoaded" class="tt-w-embedded-submission__loading"><div class="tt-o-spinner"></div></div>        
  <tt-submission-mediator v-show="isFormLoaded" 
                          @pageLoading="pageLoading"
                          @pageLoaded="pageLoaded"
                          @showPopoverMessage="onShowPopoverMessage"
                          @showError="onShowError"></tt-submission-mediator>
  </div>
  <div class="tt-w-embedded-submission__footer" :role="header ? 'footer' : null">
    <p class="tt-w-embedded-submission__poweredby" v-html="poweredByText"></p>
  </div>
</div>
